import React from "react";

function NoSubscription({ subscription = [""], isNoHidsSelected = false }) {
  return (
    <div className="content-wrapper no-data">
      <h4>No Data for Selected Properties</h4>
      {isNoHidsSelected ? (
        <h6>There is no data to be shown for the selected Hotels</h6>
      ) : (
        <h6>
          We are unable to display data for properties without a{" "}
          {subscription?.length > 0 ? subscription[0] : ""} subscription
        </h6>
      )}
    </div>
  );
}

export default NoSubscription;
